import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

export const fetchFaqList = createAsyncThunk(
  "faq/fetchFaqList",
  async (page = "home") => {
    const response = await axios.get(`${config.apiUrl}/faq?page=${page}`);
    return { page, data: response.data.data || [] };
  }
);

const FaqListSlice = createSlice({
  name: "FaqList",
  initialState: {
    pages: {},
    loading: {},
    errors: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqList.pending, (state, action) => {
        const page = action.meta.arg || "home";
        state.loading[page] = true;
        state.errors[page] = false;
      })
      .addCase(fetchFaqList.fulfilled, (state, action) => {
        const { page, data } = action.payload;
        state.loading[page] = false;
        state.pages[page] = data;
      })
      .addCase(fetchFaqList.rejected, (state, action) => {
        const page = action.meta.arg || "home";
        state.loading[page] = false;
        state.errors[page] = true;
      });
  },
});

export default FaqListSlice.reducer;
